import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue";
import { VRow, VCol, VRadio, VRadioGroup, VSelect } from "vuetify/lib";
import { VacationFlowDat } from "@/models/transaction/VacationFlowDat";
import { InputRules } from "@/rules";
import { EnumWorkClassification } from "@/models/enum/Enum";
import {
  PulldownResponse,
  codeKbnFilter
} from "@/models/response/PulldownResponse";
import { CodeKbnList, CodeKbnType } from "@/models/codeMaster/Code";
import { $get } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";

type ReasonKbn = typeof ReasonKbn[keyof typeof ReasonKbn];

export type FormType = {
  vacationKbn?: EnumWorkClassification;
  resonKbn?: ReasonKbn;
  resonText?: string;
};

type Props = {
  value: FormType;
};

type Emits = {
  (e: "update:modelValue", value: FormType): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'VacationForm',
  props: {
    value: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "update:modelValue", value: FormType): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: FormType;
};

const vacationKbn = [
  { text: "有給", value: EnumWorkClassification.PAID_HOLIDAY },
  { text: "欠勤", value: EnumWorkClassification.ABSENCE_DAY },
  { text: "特別休暇", value: EnumWorkClassification.SPECIAL_HOLIDAY },
  { text: "その他", value: EnumWorkClassification.OTHER }
];

const ReasonKbn = {
  self: "1",
  ceremonial: "2",
  special: "3"
} as const;
const reasonKbn = [
  { text: "私用", value: ReasonKbn.self },
  { text: "慶弔", value: ReasonKbn.ceremonial },
  { text: "特別", value: ReasonKbn.special }
];

/*const selfReason = ["通院", "家庭の事情", "体調不良", "その他"];

const ceremonialReason = [
  "配偶者の死去",
  "子、父母、同居の義父母の死去",
  "血族の兄弟姉妹、同居の祖父母の死去",
  "結婚休暇",
  "子の結婚休暇",
  "妻の出産休暇",
  "その他"
];

const specialReason = ["病院様都合", "会社都合", "その他"];*/



const reasonList = ref<string[]>([]);

const modelValue = computed({
  get: () => props.value,
  set: newValue => emits("update:modelValue", newValue)
});

const isVacationKbnOther = computed(
  () => modelValue.value.vacationKbn === EnumWorkClassification.OTHER
);
const isVacationKbnSpecial = computed(
  () => modelValue.value.vacationKbn === EnumWorkClassification.SPECIAL_HOLIDAY
);
const isVacationKbnPaidHoliday = computed(
  () => modelValue.value.vacationKbn === EnumWorkClassification.PAID_HOLIDAY
);
const isVacationKbnAbsence = computed(
  () => modelValue.value.vacationKbn === EnumWorkClassification.ABSENCE_DAY
);

const isReasonCeremonial = (kbn: ReasonKbn) => {
  return kbn !== ReasonKbn.ceremonial && isVacationKbnOther.value;
};
const isReasonSpecial = (kbn: ReasonKbn) => {
  return kbn !== ReasonKbn.special && isVacationKbnSpecial.value;
};
const isReasonSelf = (kbn: ReasonKbn) => {
  return (
    kbn !== ReasonKbn.self &&
    (isVacationKbnPaidHoliday.value || isVacationKbnAbsence.value)
  );
};

const getCodeMaster = async (type: CodeKbnType) => {
  const code = await $get<PulldownResponse[]>(Paths.codeMasterPulldown);
  if (code) {
    reasonList.value = codeKbnFilter(code, type).map(e => e.name);
    modelValue.value.resonText = undefined;
  }
};

watch(isVacationKbnOther, val => {
  if (val) modelValue.value.resonKbn = ReasonKbn.ceremonial;
});
watch(isVacationKbnSpecial, val => {
  if (val) modelValue.value.resonKbn = ReasonKbn.special;
});
watch(isVacationKbnPaidHoliday, val => {
  if (val) modelValue.value.resonKbn = ReasonKbn.self;
});
watch(isVacationKbnAbsence, val => {
  if (val) modelValue.value.resonKbn = ReasonKbn.self;
});

watch(
  () => modelValue.value.resonKbn,
  async newValue => {
    switch (newValue) {
      case ReasonKbn.self:
        //this.reasonList = selfReason;
        await getCodeMaster(CodeKbnList.SELRSN);
        break;
      case ReasonKbn.ceremonial:
        //this.reasonList = ceremonialReason;
        await getCodeMaster(CodeKbnList.CRERSN);
        break;
      case ReasonKbn.special:
        //this.reasonList = specialReason;
        await getCodeMaster(CodeKbnList.SPRSN);
        break;
    }
  },
  { immediate: true }
);

return { __sfc: true,vacationKbn, ReasonKbn, reasonKbn, props, emits, reasonList, modelValue, isVacationKbnOther, isVacationKbnSpecial, isVacationKbnPaidHoliday, isVacationKbnAbsence, isReasonCeremonial, isReasonSpecial, isReasonSelf, getCodeMaster, VRow, VCol, VRadio, VRadioGroup, VSelect, InputRules }
}

})